<template>
  <div id="branchMapOdp"></div>
</template>

<script>
const emptyMapJson = () => import(
  /* webpackChunkName: "emptyMapJson" */
  '../emptyMap.json'
  );

const _ = require('lodash');
const axios = require('axios');

let queryParams = '';
// eslint-disable-next-line
const NEW_API_URL = apiUrl;
// eslint-disable-next-line
var pointsClusterer;
// eslint-disable-next-line
var multiRoute = null;
const imageDefault = {
  iconLayout: 'default#image',
  iconImageHref: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAhCAYAAAAswACjAAAABGdBTUEAALGPC/xhBQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAGaADAAQAAAABAAAAIQAAAADqakYjAAAEJklEQVRIDaVWTWhcVRQ+986bzKST1Or8pAQiQa1WEJRGjS0ILZaqTU1jqIsu2uBKUIoKpSvBlOBGcaFoF1YojQsXIs3kp22i4t+i1jaltmIrlCQmUpP5yd9kZvLezLvHc4e8x5v73iQzemG453zfd86Z+3dmGKwzrkKbvzXW0oHID3CGT5G0lT6b6JOjz5RAdoUxMTyVmBl5EsYLhHkO5okCsHS081UEXy9j0FJBY8OIMMPA7A0nB88QiDaxZriKJEL7t2qbAl8ig92qeCOfIfxQzOmHY9nzs05tWZG5ezoe0AJ135Gg1Smq0Z4q6sZzTUsjE1acXeRu40uRYL3vEgJ7yCL/68wA76zmzZ3NmaGUzKFZiYL12ue0mZ4F+JYG8L/YDtqObcDvbQSRyYH5+yQYw7+AmJu3Utiz/KIyH2SgS4KllSQjnZ2c++K2as1gPh8E3+yG+mPddKcCKg1QNEE/Owq5vi8A87qLF8I8GE0NDpaKzEdfHqeD3uFUsTo/NJw5Af69bU7Y0zZvTEDm0LsglrJlPF2Ea/clz7WxVLjraeZjl8tYckLvvwaBnudVuKJf+P46rBzuA6T77BxoYjvnGi/tm5PQHn+wpgIy1r/nCfAfeMaZpmTL/FwI3KUytazAGRvsecHplmyZn9OLflhl/LseU6GqfK39UZCXxTlkfk5A2AlKmze7IFXi7ddpwCKbVS7M6ZjKT4okaFTsdWoCt6+7YhmnO7yoKs0/Z1SoKh+TSyAWV8q0tIJFuV13ylByChd/VaGqfMMjjhYxyelaX1Uz6P1jgAsZFV7fLxRh9dSAS0MtZpwLEGMqI19u9u1TdDiu41Kltp872Q/mxD+2bxtm8Vs+nfz7GwJK3dImyDAuXIbsGx8B5A0n7LaFgDz1rtXTw24OYNlI40UufzYZY6e9FPrXP8HSnrfA+OpHgFWlGDXHwugVWN53AvKfnPMKB2R4thmGcqUGORfqbNJCPnkBGjzVBLKAH3zb7wce3gximVr97WnAlXwluXwXumHojzQvnv+rVEQqU01d7zBkfRWjaibww3Bi4LgMk1e4NBbm9A+o+h+W//9mnBRCnLRy2EW2wQUdRfEIEcrmW9KqZ9NE7KEfK/sN2EVkimhq6Bp1zWNVp/MQ0pN4L5aM/+ykyopIIpoa+IyeB93d2gcdcPzTRNzeJiuDq4gkbiYXjlPAoCWqcr5uCvNIL4BQ9ZTLe0zC7mBjbMsQA7bXW+FEcZoOeiedw10natkVi0jBLOwL1UVDwxv8m0yjaTwbSY/cspKqs+d2WaKtMJbNJmf3I+CohSnzCpqiY70CUr9uESlogUv5hYR+kLZNbbFGsSgORdJx1z8dGeccGxaRYvmGfkvMv0J7278WLEwmjjbNxyut0FmjNruXVk7t5+NUrPv1WiL/BTf9e7fMkYsVAAAAAElFTkSuQmCC',
  iconImageSize: [25, 33],
  iconImageOffset: [-12, -33],
};
const imageActive = {
  iconLayout: 'default#image',
  iconImageHref: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAA4CAYAAACL3WrLAAAABGdBTUEAALGPC/xhBQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAKqADAAQAAAABAAAAOAAAAADt8kPTAAAK/0lEQVRoBc1aC3gU1RU+d3Z2N28IJBtFq0C1ykPU9qPloTUCKqkCAb+iqGiMD6QtQotfrS8IorRoEaWAD/z6oShPgSSIYG0kCPVFCRVFQISEVyDZhZBkX5mdmdtz7maW7O7MbojR9nzfZO6c1/33zL33nHsnDDpIqwFsw7oX/gwkGA6M/RTd9GEAedjuIlxy3sgB6rC9FzivAh0qPjxVunM8gNaRLtH3uVFt9qiLHLI8iUlQBBx6xFozuyxYPKTGigAY1HIdliqq+mqPhg1H4hWsOe0GejLjRpecljaTMekBjJCdXMr9eoGcfyXIP78cbJf9CKQLcgBagQIC1Y97QNt/FNTP94Fa+QWoe6rDSBgLca4vUf3+Wed5/1FvDe+spF1APa5xExmDFxFgN4qYY8IwcBaNBFvfi896akdL+/owtCzdDMqKD0FEnLHTnMO0nPp1y5KZJwRaDfkpmbnZixBkMTlyjB4CqTPvCUcumecEcop0YNYboJR/LLQQ7N+b3Q2/7QWVQSszS6CnuhVkgZyyEQ2vkbqkQ9qCKWC/aaCVnw7xQ+/vAP/DfwO90Uf220EN3tz99KYmM2emQN05ozMlZqvAwT/QdumFkPHW4yBdnGdm/515+uE68N41B7QDxwAn5w6da8NzPeXNsY6lWMYWyJclybZKgOxzEWSun/29gaS+KQDUhw37oj6pb8IQiysO6BW52bNQqUDqkQOZK2cAy8mKten0Z+qD+qI+qe9WDFH9RL36+twx19okWyXObClz01/A1q9nlHKiB+5uFEsR9zQC13WQsjNA6t3jnN6GtqcGmgv+RCuCrulavstdts3oMwKUwj3Alb0LBf3TZtwNzt+MMXSs794AtCz7AJR3Pjq7RsZo2y7MBXvhNZByXwGw87vHSOMfW14uA/+sN0nw1e76hquvh0qROSJA3TljJkmS9AqNlayKeTh44kZFlFdleQUEZi8DvSFu3EfpGQ/MYYeUyaMhZTomUUfcEDTUAPBtNA2fDtreI9jUH8r1lL1KQoEmPIHYo8RIKylKDFJRwffQfPD9YXG7QZJfroQg8NJaaL7lceDuM8QyJwyQwIBSSWKPGhNLAB2Q26UQp1wvecCPQb7uSnMHxFU18N47F5TS7dY6SSTq7oPQPOYp4B7T5VJYEwbCQpjC2Fojivl7Imk4i0cKRas/lE1CFVVW4nbztUO14Lv/efGarYwMLAY2iTIQZ2wkc9rBfvMgKztQP9sLwSWUqKxJt3M4cG+zuKidiEKffg0tr1n7IyyEibARRkmzyUOx2HDIg/sCy0yz9E0TJxnV3hCAQ7f5xHX8xkAydQjOXwPgM0/vhIUwETbCKMmS/VryKA/uZ+lY230I1H/vt5QzrFpsPc+DtBMyMAwkXem1suCxBKsH5fiWd7Za+jUwEUYZEQuE8oDelgbKhk8sZSRIf/0RMWxSN34Kzgf/LHTzSh4TvNB7n4G3+DlL+9C7n4DznptM5RFMiFHWAS6hxZSyiBXR+ExE8tD+QiwP6Q/pR8NrJLWJ5CHWb4rk6g58U1jn4RaGHqPIwCQwnnKNdaM0J7tmBUCKI0rReGi8ohh0TJFtiaU6IfWPtyOLg/ZlDThuvx6UlVvAdkVPoRbhYYlh6088BoHnVgIPtAh52z9ddr5qXuMGFWjoOYFUPRJnkMlsNkuQpMUb/XSLIsf4fHBipnFOxlSbmQrN42eJOz1H8TJSxTPpko0Z8XA9Gi/CwBE2wihjwG0gxYc9ysqOPwQzS1vSvzmG+0l8KUj6t8fBdskF4h7HO3D8rB7VnCZkbAhNRIhOAqbrMk4maMRqpTu0IBBct8xIcmWDVn0iShT6ZA80DZ0ieKklRWAfORBCm3ck5Gk1J6N8GA/M1dVoRt8xEJR6cQR7ceRzzGWsO2/yAcs1N6ByLxYoeTQ6pl0oEd3jeL/oE+EJpZg/tHNluNUxI97gFWyGgw+Bsmp86qVVnwTZAqgdc6+Cy4gV+acvBscdI0BZuxXS5twv1PyPLwHHrdeBsvyfVmaCT76tSD9W3ypihyUOfB896Rbjh2T2WwYDs1gRSK5s+hy8E+eA1DUT64UCcVGbeCRLRI5f51uKNRz7RBzYQYnrfDc9qDu/oZspMazWnRNvMJW1Zaq4b6cKiy7Rbis0acsDLwunSRMZsbRd34Ylmr4TX31oC84iULd/aaEeZqc8chsoZR+DXt9gqad+vheaBv9OyLWjxmszV2eyLTJMzDXw9+KEJeJM/1TK9byHoeRHtCP1+PrDoTYzpAGf/vI0SLiUoCEBTAaS/Kc+dTcmB+u0zWtPiSof84Rnkae8ShTOOrC1ZKys/YhulkSpMn1xcrCWDloFqVNvBeekWxKqKWX/wsyKM4izd0twCgmgoKtvkZVClUzrIm7lxT5qMGSsnglSXjcrFUs+Tcj0v06GlMfusNQxBC2YegVpusAmgOZ6NlRhabZTO+YGqmaSEdWJWdtegpRJo4ByfjKiMpDOrbK2vgiOu0YkU8f58hVo+46Q3qGFp0oF4kjudOcUTsDN1HIZx03mB88ndWYoUJ4OYXkX+mg3jqnD4Y0bvhWWnSmOIuVBfYHegoTb5vaS9/bZEKr8DxVVU3Pc6xeQXQSo2NfndduP0t4Zr00HO0bgf0FUUjaPeZKQebS6hl4uqBTpKTxGERFt9HVQnyBwgTlv44AV+/4fFiuGMFDyhuhTB32OAZIYEaD0kFtXvgrTwA7K18EFYiEg9g9GdKih7jqAweTfnqlTFrftOAooCrgG2iSstrXggvUgSrm22t9jmw53/a3RVLn28KWwKarCjgUKLnf5LhynL1B55Zs8/wcbAv5pC4E3+ymvL3W5N2yKjUkcUFI4XR98Cm+71T01EHj6zVibTn9uwfOC0DZM4YwdYWpgqlkHpkAp7KGQcicaBoKvbwRldaWZbafwtKoD4rANnXFdU4usjsZNgRKC8xo2fqXpehEt1v5HXgEtQXXVUcR0WEZbaRpmWMs/g0fireko3qMlUFJ1uUtX67r2LDkSDk+ejvfQUQ6Wgr4H5oFOPjlsXFRfWpLIFe7aElOaf3/loPQ+V3Ff8HIVx5EDD2UTFdGJvZ2V+qe/AspmKqrZgaYQLxgb3JfwDChhRMltCVYueEw9EWuBKppc3jufBfBHrRykdk4UfGENtKyooOxzhmstY3qdKT2TzEFSoOSAPqe0BIJ0JrmfzqC8xXM7vGwpayoh+PwqmuEhXdPG5ZzamPgYpvUXtAso6Z7v3eTGD1YjsIPDIfyu6XtwHm4Ozi3Nqlu/AP/vwwkHs+V9iSZPK77Ird1AyQKXjmNaQCWwJ2l8+YqxympnTaB9cTA8IXES4bHFE+35/hlBiY1I9dSWmaztzvnVTySbcwvO1h72/KsgY+mjCY+EdKwd6Oxep087jC3MqVs3JVkfsfJziqhhTPssNch/iUvsUaob6RMh+M0PZMVaedvTAiT+sNUL69aZZh7Dt9W9QxE1nJ3oWtjT4WQU2Z609c14+0lgWWmGWORub+EM4xtUBabmm2OLjYhykkaHImr4PP9MaQ2EgtfiANpH55zesTPOfu2gzzxFcwVIWtpwIo7rKEjq7ztF1AB8IqMg157mfJ8Bu5pO9TJx8+efuRSUDR/TkeFBzasNzfOV0/+XdJg6BSj1Xt21sGuWQ8LPHHwIS3MCp6TAoA7H8tC8xtKDHUbYathpQMlfPeRn2FzZZdgchlezxrXrRH1Lwv83qsZ/7/C4xq71dB9FYDuN/gvhkHvkeByXXgAAAABJRU5ErkJggg==',
  iconImageSize: [42, 56],
  iconImageOffset: [-21, -56],
};

// eslint-disable-next-line
let myMap;

function createMap(clusterBounds, selectedPoint) {
  // eslint-disable-next-line
  myMap = new ymaps.Map('branchMapOdp', {
    controls: ['zoomControl'],
    bounds: pointsClusterer.getBounds(),
  }, {
    maxZoom: 18,
  });

  // eslint-disable-next-line
  const searchStartPoint = new ymaps.control.SearchControl({
    options: {
      noPopup: false,
      placeholderContent: 'Введите ваш адрес',
    },
  });
  myMap.controls.add(searchStartPoint, {
    float: 'left',
    floatIndex: 1,
  });
  //
  if (selectedPoint) {
    // eslint-disable-next-line no-underscore-dangle
    myMap.setCenter(selectedPoint.geometry._coordinates, 18, {
      checkZoomRange: true,
    });
  } else {
    myMap.setBounds(clusterBounds.getBounds());
  }
}

export default {
  props: {
    initPointsData: Object,
    searchODP: String,
    ODPPreview: Object,
  },
  name: 'YmapsView',
  components: {},
  data() {
    return {
      map: null,
      localGeoArea: [],
      pointsGeoObjects: [],
      sourceObjects: [],
      focusODP: '',
      ymapsMultiRouteCoords: [],
      userPosition: [],
      queryParams: ['id', 'geo'],
      concatQueryParams: [],
      enableODPCourier: false,
      findODPViewPort: null,
      selectedPoint: null,
    };
  },
  methods: {
    searchODPCourier(data) {
      const rule = (el) => el.courierDelivery === true;
      const enableCourier = data.every(rule);
      if (data.length) {
        this.enableCourier(enableCourier);
      } else {
        this.enableCourier(false);
      }
    },
    initMapView(odp, clear, resetMap) {
      if (!odp || !odp.length) return;
      const self = this;
      // eslint-disable-next-line
      ymaps.ready(() => {
        if (clear) {
          this.sourceObjects = [];
          this.pointsGeoObjects = [];
          myMap.geoObjects.removeAll();
        }
        // eslint-disable-next-line
        let clusterBounds = new ymaps.Clusterer();
        const fakeClusterCollection = [];
        odp.forEach((odpItem) => {
          if (odpItem.geo && odpItem.geo.latitude && odpItem.geo.longitude) {
            // eslint-disable-next-line
            const point = new ymaps.GeoObject({
              geometry: {
                type: 'Point',
                coordinates: [odpItem.geo.latitude, odpItem.geo.longitude],
              },
            }, imageDefault);
            point.odp = odpItem.id;
            fakeClusterCollection.push(point);
          }
        });
        clusterBounds.add(fakeClusterCollection);

        // eslint-disable-next-line
        pointsClusterer = new ymaps.Clusterer({
          preset: 'islands#redClusterIcons',
        });
        if (clear) {
          myMap.geoObjects.removeAll();
        }
        const pointsKeys = odp;
        pointsKeys.forEach((odpItem, key) => {
          if (odpItem.geo && odpItem.geo.latitude && odpItem.geo.longitude) {
            // eslint-disable-next-line
            const point = new ymaps.GeoObject({
              geometry: {
                type: 'Point',
                coordinates: [odpItem.geo.latitude, odpItem.geo.longitude],
              },
            }, imageDefault);
            point.odp = odpItem.id; // добавим поле для отдельного, детального запроса
            const innerInfo = document.querySelector(`.map-list__item[data-id="${key}"] .map-card`);

            if (innerInfo) {
              innerInfo.dataset.arrayIndex = this.pointsGeoObjects.length;
            }
            point.events.add('click', (e) => {
              if (self.selectedPoint) {
                self.selectedPoint.options.set(imageDefault);
              }
              self.selectedPoint = point;
              self.setActivePointIndex(point, e.originalEvent.target.odp);
            });

            this.sourceObjects.push(odpItem);
            this.pointsGeoObjects.push(point);

            if (!this.selectedPoint && this.ODPPreview && this.ODPPreview.id === odpItem.id) {
              this.selectedPoint = point;
              this.setActivePointIndex(point, odpItem);
            }
          }
        });

        pointsClusterer.add(this.pointsGeoObjects);

        if (!myMap) {
          createMap(clusterBounds, this.selectedPoint);
        }
        if (!clear) {
          myMap.setBounds(clusterBounds.getBounds());
        }

        if (clear) {
          this.pointsGeoObjects = [];

          if (resetMap) {
            myMap.destroy();

            createMap(clusterBounds, this.selectedPoint);
          }
        }


        this.localGeoArea = myMap.getBounds();
        myMap.geoObjects.add(pointsClusterer);
        myMap.events.add('boundschange', () => {
          self.localGeoArea = myMap.getBounds();
          //   eslint-disable-next-line no-use-before-define
          self.getMoreTouchPoints();
        });
        self.getMoreTouchPoints();

        // myMap.setCenter(point.geometry._coordinates, 18, {
        //   checkZoomRange: true
        // })
      });
    },
    setActivePointIndex(point, ODPCode) {
      if (point) {
        this.setActivePointOnMap(point);

        this.$emit('select', point.odp);

        if (myMap) {
          // eslint-disable-next-line no-underscore-dangle
          myMap.setCenter(point.geometry._coordinates, 18, {
            checkZoomRange: true,
          });
        }
      }

      this.focusODP = ODPCode;

      if (myMap && multiRoute !== null) {
        myMap.geoObjects.remove(multiRoute);
      }
    },
    setActivePointOnMap(point) {
      if (this.selectedPoint) {
        this.selectedPoint.options.set(imageDefault);
      }

      this.pointsGeoObjects.forEach((unactivePoint) => {
        unactivePoint.options.set(imageDefault);
      });
      if (point) {
        point.options.set(imageActive);
      }
    },
    getPoints(code, clear, resetMap) {
      let pagesLoaded = 0;
      const odpRes = [];
      const self = this;

      function fetchPoints(page = 1) {
        axios.get(`${NEW_API_URL}/odp?cityCode=${code}&perPage=1000${queryParams}&page=${page}&filter=pip&select=id,geo`)
          .then((resp) => {
            pagesLoaded += 1;
            odpRes.push(...resp.data.odp);
            self.findODPViewPort = resp.data.pager.nbResults;
            if (page === 1) {
              for (let i = page; i < resp.data.pager.lastPage; i += 1) {
                fetchPoints(i + 1);
              }
            }
            if (pagesLoaded !== resp.data.pager.lastPage) return;

            if (clear) {
              self.initMapView(odpRes, clear, resetMap);
            } else {
              self.initMapView(odpRes);
            }
          })
          .catch((error) => {
            console.log(error);
            emptyMapJson().then((module) => {
              self.findODPViewPort = module.default.data.pager.nbResults;
              self.initMapView(module.default.data.odp, clear, resetMap);
            });
          });
      }
      fetchPoints();
    },
    getMoreTouchPoints(clear) {
      let pagesLoaded = 0;
      const odpRes = [];
      this.cancelSearch();
      this.cancelSource = axios.CancelToken.source();

      const isOpenOnWeekends = this.isOpenOnWeekends ? `&isOpenOnWeekends=${1}` : '';
      const acquiring = this.acquiring ? `&acquiring=${1}` : '';
      const interRefunds = this.interRefunds ? `&interRefunds=${1}` : '';
      const receptionLap = this.receptionLap ? `&receptionLap=${1}` : '';

      queryParams = isOpenOnWeekends + acquiring + interRefunds + receptionLap;
      const self = this;

      function fetchMoreTouchPoints(page = 1) {
        axios.get(`${NEW_API_URL}/odp?geoArea=${self.localGeoArea}&perPage=1000&select=id,geo,courierDelivery${queryParams}&page=${page}&filter=pip`)
          .then((resp) => {
            if (resp) {
              self.cancelSource = null;
              pagesLoaded += 1;
              odpRes.push(...resp.data.odp);
              if (page === 1) {
                for (let i = page; i < resp.data.pager.lastPage; i += 1) {
                  fetchMoreTouchPoints(i + 1);
                }
              }
              if (pagesLoaded !== resp.data.pager.lastPage) return;

              if (odpRes.length) {
                if (clear) {
                  self.initMapView(odpRes, clear);
                } else {
                  self.initPointsMore(odpRes);
                }
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
      fetchMoreTouchPoints();
    },
    num2str(n, text_forms) {
      n = Math.abs(n) % 100;
      const n1 = n % 10;
      if (n > 10 && n < 20) {
        return text_forms[2];
      }
      if (n1 > 1 && n1 < 5) {
        return text_forms[1];
      }
      if (n1 == 1) {
        return text_forms[0];
      }
      return text_forms[2];
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel('Start new search, stop active search');
      }
    },
    initPointsMore(odp, clear) {
      const self = this;
      //  делаем выборку, и вылетевшие добавляем на карту
      const newOdp = _.differenceWith(odp, this.sourceObjects, (arrVal, othVal) => arrVal.id === othVal.id);

      if (clear) {
        myMap.destroy();
        this.pointsGeoObjects = [];
        // eslint-disable-next-line
        myMap = new ymaps.Map('branchMapOdp', {
          controls: ['zoomControl'],
          bounds: pointsClusterer.getBounds(),
        }, {
          maxZoom: 18,
        });

        if (odp.length < 10) {
          myMap.setZoom(18);
        }

        // eslint-disable-next-line
        const searchStartPoint = new ymaps.control.SearchControl({
          options: {
            noPopup: false,
            placeholderContent: 'Введите ваш адрес',
          },
        });
        myMap.controls.add(searchStartPoint, {
          float: 'left',
          floatIndex: 1,
        });
      } else if (newOdp.length) {
        newOdp.forEach((odpItem) => {
          if (odpItem.geo && odpItem.geo.latitude && odpItem.geo.longitude) {
            let pointImage = imageDefault;
            // проверяем на активный ПВЗ чтобы иконка оставалась активной
            if (self.focusODP === odpItem.id) {
              pointImage = imageActive;
            }
            // eslint-disable-next-line
            const point = new ymaps.GeoObject({
              geometry: {
                type: 'Point',
                coordinates: [odpItem.geo.latitude, odpItem.geo.longitude],
              },
            }, pointImage);
            point.odp = odpItem.id; // добавим поле для отдельного, детального запроса

            point.events.add('click', (e) => {
              if (self.selectedPoint !== '') {
                self.selectedPoint.options.set(imageDefault);
              }

              self.selectedPoint = point;
              self.setActivePointIndex(point, e.originalEvent.target.odp);
            });

            self.pointsGeoObjects.push(point);
            self.sourceObjects.push(odpItem);

            if (this.ODPPreview && this.ODPPreview.id === odpItem.id) {
              if (!this.selectedPoint) {
                this.selectedPoint = point;
                this.setActivePointIndex(point, odpItem);
              } else {
                this.selectedPoint = point;
                this.setActivePointOnMap(point);
              }
            }
          }
        });
        pointsClusterer.add(this.pointsGeoObjects);
        myMap.geoObjects.add(pointsClusterer);
      }
    },
    getUserLocation(odp) {
      // eslint-disable-next-line
      const self = this,
        // eslint-disable-next-line
        location = ymaps.geolocation.get();

      // Асинхронная обработка ответа.
      location.then(
        (result) => {
          self.userPosition = result.geoObjects.position;

          // Добавление местоположения на карту.
          myMap.geoObjects.add(result.geoObjects);

          // Вызов отрисовки, ToDo:надо еще обработать отказ определения положения
          // console.log(odp);
          self.routeBuild(odp);
        },
        (err) => {
          console.log(`Ошибка: ${err}`);
        },
      );
    },
    routeBuild(odp) {
      // eslint-disable-next-line
      if (multiRoute === null) {
        // eslint-disable-next-line
        multiRoute = new ymaps.multiRouter.MultiRoute({
          referencePoints: [
            [this.userPosition[0], this.userPosition[1]],
            [odp.geo.latitude, odp.geo.longitude],
          ],
        }, {
          boundsAutoApply: true,
          // mapStateAutoApply: true
        });
        myMap.geoObjects.add(multiRoute);
      } else {
        myMap.geoObjects.remove(multiRoute);
        multiRoute = null;
        this.routeBuild(odp);
      }

      this.ymapsMultiRouteCoords = [odp.geo.latitude, odp.geo.longitude];
    },
  },
  mounted() { },
  watch: {
    ODPPreview(odp, prevOdp) {
      if (odp && !prevOdp) {
        // eslint-disable-next-line
        window.ymaps.ready(() => {
          if (odp.geo && odp.geo.latitude && odp.geo.longitude) {
            const point = new window.ymaps.GeoObject({
              geometry: {
                type: 'Point',
                coordinates: [odp.geo.latitude, odp.geo.longitude],
              },
            }, imageActive);
            point.odp = odp.id;
            point.events.add('click', (e) => {
              this.$emit('select-odp', { point, odp });

              if (this.selectedPoint !== '') {
                this.selectedPoint.options.set(imageDefault);
              }

              this.selectedPoint = point;
              this.setActivePointIndex(point, e.originalEvent.target.odp);
            });

            this.setActivePointOnMap(point);

            if (myMap) {
              myMap.setCenter([odp.geo.latitude, odp.geo.longitude], 18, {
                checkZoomRange: true,
              });
            }
          }
        });
      }
    },
    initPointsData: {
      handler() {
        try {
          this.initMapView(this.initPointsData.data.odp);
        } catch (e) {
          console.error(e);
        }
      },
    },
    searchODP: {
      handler() {
        if (this.searchODP.length) {
          this.setActivePointIndex(null, this.searchODP);
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>

</style>
